export default (t, delivery, phone, serviceTime) => ({
  male: [
    {
      title: t('Herrenmode mit Stil und Geschmack'),
      description: t(
        'Der moderne Gentleman interessiert sich für aktuelle Herrenmode. Unabhängig davon weiß er genau, was er will und hat ein Händchen für geschmackvolle Mode. Er weiß seine natürlichen Vorzüge gekonnt in Szene zu setzen und achtet bei der Wahl seiner Bekleidung auf ein stilvolles Design, hochwertige Qualität und bequemen Komfort.',
        {
          keySeparator: '>',
        },
      ),
    },
    {
      title: t('Klassische Herrenmode für Männer'),
      description: t(
        'Mann weiß, was zu ihm passt! In den Kleiderschrank eines jeden Herren gehören bestimmte Herrenmode Klassiker, die stets klassisch schön sind und jedem Mann schmeicheln. Dazu gehören bei der Oberbekleidung unifarbene Hemden, vorzugsweise in Weiß oder Schwarz. Nie verkehrt ist ein stilvoller Trenchcoat in den Farben Beige oder Schwarz. Basic-Shirts sind vielseitig kombinierbar und komplettieren garantiert Deinen modischen Look. Eine edle Strickjacke erlaubt es Dir Akzente zu setzen und Dein Gespür für erlesene Herrenmode unter Beweis zu stellen. Zeitlose Herrenbekleidung, wie die schwarze Stoffhose oder eine hochwertige Jeans, sollte zur Grundausstattung eines jeden Herren gehören. Ebenso, wie ein modisch unvergängliches Schuhe für Herren. Wildledersneakers oder Bootsschuhe sind jederzeit en vogue und vervollständigen Dein Outfit. Anzüge und Sakkos sind elegante Dauerbrenner der Herrenmode. Jeder Mann sollte mindestens einen aparten Anzug besitzen!',
        {
          keySeparator: '>',
          nsSeparator: '|',
        },
      ),
    },
    {
      title: t('Herrenmode Trends: Abwechslung für Deinen Look'),
      description: t(
        'Als modischer Herr solltest Du Dich auch an neue Trends und Bekleidungsstücke wagen. Für ein junges sportliches Herrenmode Outfit haben wir eine riesen Auswahl an passender Herren Sportbekleidung. Dazu angesagte Print-Shirts mit einem modischen Aufdruck verleihen jedem Look das gewisse Etwas. Bunte Herrenmode, vor allem in knalligen Farben, ist etwas für Männer mit Wagemut und Experimentierfreude. Bunte Shorts machen sich hervorragend zum weißen Shirt, während angesagte Sneakers oder Boots Deine Modeexpertise bekräftigen. Auch Espadrilles oder Slipper in ansprechendem Design gehören zu den Essentials eines aufregenden und gepflegten Outfits. Accessoires für Herren wie Caps, Taschen oder Schals machen Deinen stilgerechten Herrenlook komplett.',
      ),
    },
    {
      title: t('Online bei ABOUT YOU Herrenmode kaufen'),
      description: t(
        'Angesagte und zeitlose Mode für Herren findest Du im Onlineshop von ABOUT YOU. Dich erwarten zahlreiche Qualitätsmarken, ein reichhaltiges Sortiment und Herrenmode mit Stil. In Ruhe kannst Du Dich durch das breitgefächerte Angebot des Shops stöbern und eine Auswahl treffen, für jede Größe finden sich hier die passenden Bekleidungsstücke. Auch für große Männer hält ABOUT YOU die richtige Herrenmode parat. Anschließend erledigst Du mit nur wenigen Klicks schnell und unkompliziert Deine Bestellung. In nur wenigen Tagen erhältst Du Deine neuen Modefavoriten zu Dir nach Hause geliefert.',
      ),
    },
  ],
  female: [
    {
      title: t(
        'Große Auswahl, einfache Bestellung – Damenmode online bei ABOUT YOU',
      ),
      description: t(
        'Die Liebe zum Shoppen gehört zur Dame wie der Dotter zum Ei. Im Bereich Damenmode kennt sich ABOUT YOU bestens aus. Eine große Auswahl verschiedener Labels bietet Dir alles, was Du für Dein nächstes Outfit brauchst: von A wie Accessoire bis Z wie Zipper. Begib Dich auf die Suche nach aktuellen Trends oder lass Dich von klassischen Schnitten und Modellen inspirieren. Deine bestellten Artikel werden Dir schnell und bequem nach Hause geliefert. Sollte eines der Produkte nicht Deinem Geschmack entsprechen, kannst Du es kostenfrei zurückschicken.',
        {
          keySeparator: '>',
          nsSeparator: '|',
          deliveryTime: delivery,
        },
      ),
    },
    {
      title: t(
        'Oberbekleidung und Jacken – Damenmode ganz nach Deinem Geschmack',
      ),
      description: t(
        'Egal, ob Bluse, Kleid oder T-Shirt: bei ABOUT YOU findest Du alles für Deinen stimmigen Look. Auf eine große Auswahl an Größen und Farben musst Du dabei nicht verzichten. Besonders farbenfrohe Modelle machen Lust auf Sommer. Mit den dezenten Oberteilen machst Du eine gute Figur in Herbst und Winter. Damit Du in der kalten Jahreszeit nicht frierst, kannst Du gleich die passende Jacke mitbestellen. Innovative Features wie ein herausknöpfbares Innenfutter, dicke Kapuzen oder eine extra taillierte Passform machen die Jacken und Mäntel zu einem absoluten Must-Have für Deinen Kleiderschrank.',
        {
          keySeparator: '>',
          nsSeparator: '|',
          deliveryTime: delivery,
        },
      ),
    },
    {
      title: t('Schickes Gewand für das Bein'),
      description: t(
        'Du benötigst eine Hose für einen bestimmten Anlass oder möchtest einfach nur Deinen Kleiderschrank füllen? Dann sieh Dich bei ABOUT YOU um. Die große Auswahl an Hosen umfasst sowohl trendige Boyfriend Jeans als auch klassische Stoffhosen. Alle Marken bieten Dir die Möglichkeit, Deine individuelle Hosengröße mit Hilfe des Größenberaters herauszufinden. Gib einfach die Größe Deiner bisherigen Hosen an und finde mit einem Knopfdruck die herstellerspezifische Größe eines bestimmten Modells. Unkomplizierter geht es wirklich nicht.',
      ),
    },
    {
      title: t('Unverzichtbar für jede Dame'),
      description: t(
        'Ob High Heels, Sneakers oder Pumps, Schuhe üben einfach eine magische Anziehungskraft auf Damen aus. Passende Modelle für Frühling, Sommer, Herbst und Winter findest Du bei ABOUT YOU. Die farbenfrohen Ausführungen machen Lust auf die warme Jahreszeit. Mit Stiefeln und Boots bist Du auch im Herbst und Winter warm und gemütlich unterwegs.',
      ),
    },
    {
      title: t('Accessoires als krönender Abschluss für Dein Outfit'),
      description: t(
        'Was wäre Damenmode ohne Accessoires? Schmuck, Sonnenbrillen, Hüte und Taschen machen aus den langweiligsten Basics ein tolles Outfit. Wenn Du Fragen zu Deiner Bestellung hast, dann nutze gerne den ABOUT YOU Beratungsservice. Er steht Dir unter der Rufnummer {{serviceNumber}}* {{serviceTime}} zur Verfügung.',
        {
          serviceNumber: phone,
          serviceTime: serviceTime,
          interpolation: { escapeValue: false },
        },
      ),
    },
  ],
})
